"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Background = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Container = require("../../ui/Container");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Background = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
});
exports.Background = Background;
var Container = (0, _styledComponents.default)(function (_ref2) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  return /*#__PURE__*/_react.default.createElement(Background, {
    className: "mt-auto ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_Container.Container, null, children));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-top: 1px; // on large screens, the content of the footer overlaps to the border of the footer\n"])));
exports.Container = Container;